jQuery( document ).ready( function( $ ) {

      var formController = Marionette.Object.extend( {

        fieldModels: {},

        initialize: function() {
            this.listenTo( nfRadio.channel( 'form' ), 'loaded', this.onFormLoaded);

            this.listenTo( nfRadio.channel( 'form' ), 'render:view', this.initForm );
            this.listenTo( nfRadio.channel( 'fields' ), 'render:view', this.updateLayout );

            this.listenTo( nfRadio.channel( 'listselect' ), 'render:view', this.initSelectize );
            this.listenTo( nfRadio.channel( 'listcountry' ), 'render:view', this.initSelectize );
            this.listenTo( nfRadio.channel( 'listmultiselect' ), 'render:view', this.initSelectize );
            this.listenTo( nfRadio.channel( 'listradio' ), 'change:modelValue', this.updateLayout );

            this.listenTo( nfRadio.channel( 'pikaday' ), 'init', this.modifyDatePicker);

            this.listenTo( nfRadio.channel( 'date' ), 'change:modelValue', this.validateDate);
            this.listenTo( nfRadio.channel( 'date' ), 'validate:field', this.validateDate);

            this.listenTo( nfRadio.channel( 'hidden' ), 'change:modelValue', this.hiddenChange);
            this.listenTo( nfRadio.channel( 'textbox' ), 'change:modelValue', this.validateSku);
            // this.listenTo( nfRadio.channel( 'textbox' ), 'change:modelValue', this.purchasePriceChange);
            this.listenTo( nfRadio.channel( 'textbox' ), 'validate:modelValue', this.validateSku);

            this.listenTo( nfRadio.channel( 'calc' ), 'change:value', this.purchasePriceChange );

            this.listenTo( nfRadio.channel( 'forms' ), 'submit:response', this.onSubmitResponse );
        },
        onFormLoaded: function( formModel ) {
            // console.log("form loaded");

            var fieldModels = formModel.get( 'fields' ).models,
                savedModelsKeys = ['schutzbrief_kaufdatum', 'kaufdatum_geraet', 'vertragsdauer'];

            for( var model in fieldModels ) {
                var field = fieldModels[ model ];
                var fieldID = field.get( 'id' );

                this.fieldModels[ field.get('fides_field_key') ] = field;

                if ( field.get( 'fides_field_key' ) == 'schutzbrief_kaufdatum' ||
                     field.get( 'fides_field_key' ) == 'kaufdatum_geraet' ||
                     field.get( 'fides_field_key' ) == 'schaden_datum' ) {

                    this.listenTo( nfRadio.channel( 'field-' + fieldID ), 'change:modelValue', this.validateContractTerm );
                }
            }

            //this.listenTo( nfRadio.channel( 'field-' + fieldID ), 'change:modelValue', this.validateContractTerm );
            // jQuery('.nf-form-content').on( 'DOMSubtreeModified', this.updateLayout );
        },
        initForm: function( view ) {
            var $priceFields = $( view.el ).find('.price-field');
            $priceFields.number(true, 2, ',', '.');

            $priceFields.on( 'blur', function( e ) {
                $(this).trigger('change');
            });


            if (this.fieldModels[ 'schutzbrief_artikelnr' ]) {
                var fieldID = this.fieldModels[ 'schutzbrief_artikelnr' ].get('id');
                var $field = $('#nf-field-' + fieldID );
                if ($field.val() !== '') {
                  var val = $field.val();
                  this.fieldModels[ 'schutzbrief_artikelnr' ].set('value', '');
                  this.fieldModels[ 'schutzbrief_artikelnr' ].set('value', val);
                }
            }

            if ( !$.trim( $('.nf-response-msg').html() ) ) {
                $('.nf-response-msg').hide();
            }


            this.updateLayout( view.el );
        },

        updateLayout: function( el, model) {
            var $el = $('.nf-form-content');

            if (/MSIE 10/i.test(navigator.userAgent) ||/MSIE 9/i.test(navigator.userAgent) || /rv:11.0/i.test(navigator.userAgent))  {
                // add workaround for IE
                var $elems = $el.find('nf-field .nf-field-container.one-half');

                $elems.each( function( i, el ) {
                    if ( $(el).parent().hasClass('one-half') ) return;

                    if ( $(el).hasClass('first') ) {
                        $(el).parent().addClass('first');
                    }
                    $(el).parent().addClass('one-half');
                });
            }
        },
        initSelectize: function( view ) {

            $( view.el ).find('select').each(function(i, el) {
                var create = false;
                if ( $(el).hasClass('add-new-allowed') ) {
                    create = true;
                }

                $(el).selectize({
                    plugins: ['remove_button'],
                    create: create,
                    render: {
                        'option_create': function(data, escape) {
                            return '<div class="create"><strong>' + escape(data.input) + '</strong> hinzufügen&hellip;</div>';
                        }
                    },
                    onInitialize: function() {
                        this.$wrapper.removeClass('ninja-forms-field nf-element');
                    }
                });
            });
        },
        modifyDatePicker: function( dateObject, fieldModel ) {
            dateObject.pikaday._o.i18n = {
                previousMonth: 'Vormonat',
                nextMonth: 'Nächster Monat',
                months: ['Januar', 'Februar', 'März', 'April', 'Mai', 'Juni', 'Juli', 'August', 'September', 'Oktober', 'November', 'Dezember'],
                weekdays: ['Sonntag', 'Montag', 'Dienstag', 'Mittwoch', 'Donnerstag', 'Freitag', 'Samstag'],
                weekdaysShort: ['So.', 'Mo.', 'Di.', 'Mi.', 'Do.', 'Fr.', 'Sa.']
            };
        },
        validateRequiredList: function( el, model ) {
            // Do stuff here.
            if ( model.get('type') !== 'listselect' ) return;

            var val = model.get('value');
            if ( ! jQuery.trim( val ) ) {

            }
        },
        validateDate: function( model ) {

            if (model.get('type') !== 'date') return;

            var errorID = 'date-not-in-past',
                errorMessage = 'Datum darf nicht in der Zukunft liegen',
                fieldsChannel = Backbone.Radio.channel( 'fields');

            var parsedDate = moment(model.get('value'), model.get('date_format'));
            var diffDate = moment().diff(parsedDate, 'days');

            if (moment().isAfter(parsedDate)) {
                fieldsChannel.request( 'remove:error', model.get( 'id' ), errorID );
            } else {
                fieldsChannel.request( 'add:error', model.get( 'id' ), errorID, errorMessage );
            }

            if ( model.get('fides_field_key') === "schutzbrief_kaufdatum" &&
                 model.get('value') !== "" ) {
                var dday = moment('20170831', 'YYYYMMDD');
                var d2022 = moment('20211231', 'YYYYMMDD');
                var bd2022 = moment('20220101', 'YYYYMMDD');

                var mapping = {
                    // 'GZW': {
                    //   'kennzeichen': 'GZW',
                    //   // 'vertragsart': '',
                    //   // 'downgrade': true,
                    // },
                    'GEG': {
                      'kennzeichen': 'GST',
                      'vertragsart': 'GRAVIS Hardware-Schutz für Smartphones/Tablets',
                    },
                    'GCEG': {
                      'kennzeichen': 'GCST',
                      'vertragsart': 'GRAVIS Hardware-Schutz Classic für Smartphones/Tablets',
                    },
                    'GPEG': {
                      'kennzeichen': 'GPST',
                      'vertragsart': 'GRAVIS Hardware-Schutz Pro für Smartphones/Tablets ',
                    },
                    'GC': {
                      'vertragsart': 'GRAVIS Hardware-Schutz für Computer ',
                    },
                    'GCC': {
                      'vertragsart': 'GRAVIS Hardware-Schutz Classic für Computer',
                    },
                    'GPC': {
                      'vertragsart': 'GRAVIS Hardware-Schutz Pro für Computer',
                    },
                };

                var vertragsart = this.fieldModels['schutzbrief_vertragsart'];
                var kundenkennzeichen = this.fieldModels['kundenkennzeichen'];

                if ( moment( model.get('value'), model.get( 'date_format' ) ).isAfter(dday) && moment( model.get('value'), model.get( 'date_format' ) ).isBefore(d2022) ) {
                    if ( vertragsart.get('value').toLowerCase().indexOf('mac') !== -1 ) {
                        jQuery( '#nf-field-' + vertragsart.attributes.id ).val( vertragsart.get('value').replace('Mac', 'Computer') ).trigger( 'change' );

                        if ( vertragsart.get('value').toLowerCase().indexOf('pro') !== -1 ) {
                          jQuery( '#nf-field-' + kundenkennzeichen.attributes.id ).val( 'GPC' ).trigger( 'change' );
                        }  else {
                          jQuery( '#nf-field-' + kundenkennzeichen.attributes.id ).val( 'GC' ).trigger( 'change' );
                        }
                    } else if ( vertragsart.get('value').toLowerCase().indexOf('ios') !== -1 ) {
                        jQuery( '#nf-field-' + vertragsart.attributes.id ).val( vertragsart.get('value').replace('iOS', 'Elektronik-Geräte') ).trigger( 'change' );

                        if ( vertragsart.get('value').toLowerCase().indexOf('pro') !== -1 ) {
                          jQuery( '#nf-field-' + kundenkennzeichen.attributes.id ).val( 'GPEG' ).trigger( 'change' );
                        }  else {
                          jQuery( '#nf-field-' + kundenkennzeichen.attributes.id ).val( 'GEG' ).trigger( 'change' );
                        }
                    }
                }

                if ( moment( model.get('value'), model.get( 'date_format' ) ).isBefore(bd2022) && kundenkennzeichen.getValue() == 'GZW' ) {
                  jQuery( '#nf-field-' + vertragsart.attributes.id ).val( 'GRAVIS Zubehör-Schutz' ).trigger( 'change' );
                } else if ( moment( model.get('value'), model.get( 'date_format' ) ).isAfter(d2022) ) {
                  // TODO: change kundenkennzeichen and vertragsart
                  if ( kundenkennzeichen.getValue() in mapping ) {
                    var newMap = mapping[ kundenkennzeichen.getValue() ];
                    if ( 'vertragsart' in newMap ) {
                      jQuery( '#nf-field-' + vertragsart.attributes.id ).val( newMap['vertragsart'] ).trigger( 'change' );
                    }

                    if ( 'kennzeichen' in newMap ) {
                      jQuery( '#nf-field-' + kundenkennzeichen.attributes.id ).val( newMap['kennzeichen'] ).trigger( 'change' );
                    }
                  }
                }



            }
        },
        validateSku: function( model ) {

            if ( model.get( 'fides_field_key' ) === "schutzbrief_artikelnr") {

                var errorID = 'sku-not-valid',
                    errorMessage = 'Artikelnummer nicht gültig',
                    nfFields = Backbone.Radio.channel( 'fields' ),
                    validator_field = this.fieldModels[ 'artikelnummer_gueltig' ];

                if ( validator_field.get('value') == 0) {
                    this.fieldModels['vertragsdauer'].set('value', '');
                    nfFields.request( 'add:error', model.get('id'), errorID, errorMessage );
                } else {
                    nfFields.request( 'remove:error', model.get('id'), errorID );
                }
            }

        },
        validateContractTerm: function( model ) {
            // console.log("validateContractTerm");

            var nfFields = nfRadio.channel( 'fields' );

            if ( model.get('fides_field_key') === 'schutzbrief_kaufdatum' ||
                 model.get('fides_field_key') === 'kaufdatum_geraet' ||
                 model.get('fides_field_key') === 'schaden_datum' ) {

                var purchaseDateWarranty = this.fieldModels[ 'schutzbrief_kaufdatum' ],
                    purchaseDateDevice = this.fieldModels[ 'kaufdatum_geraet' ],
                    contractTerm = this.fieldModels[ 'vertragsdauer' ],
                    damageDate = this.fieldModels[ 'schaden_datum' ],
                    purchaseDateWarrantyValue = undefined,
                    contractTermEndDate = undefined,
                    purchaseDateDeviceValue = undefined,
                    damageDateValue = undefined;


                if ( purchaseDateWarranty.get('value') !== '') {
                    purchaseDateWarrantyValue = moment(purchaseDateWarranty.get('value'), purchaseDateWarranty.get( 'date_format' ));
                }

                if ( purchaseDateWarrantyValue !== undefined ) {
                    // end of contract date
                    contractTermEndDate = moment(purchaseDateWarrantyValue).add(contractTerm.get('value'), 'y').subtract(1, 'days');
                }

                if ( purchaseDateDevice.get('value') !== '') {
                    purchaseDateDeviceValue = moment(purchaseDateDevice.get('value'), purchaseDateDevice.get( 'date_format' ));
                }

                if ( damageDate.get('value') !== '') {
                    damageDateValue = moment(damageDate.get('value'), damageDate.get( 'date_format' ));
                }

                // contract expired
                if ( contractTermEndDate !== undefined &&
                     contractTermEndDate.isBefore( moment() ) ) {
                    nfFields.request( 'add:error', purchaseDateWarranty.get('id'), 'sku-expired', 'Der Vertrag ist bereits abgelaufen.' );
                } else {
                    nfFields.request( 'remove:error', purchaseDateWarranty.get('id'), 'sku-expired' );
                }

                // purchaseDateDevice is after purchaseDateWarranty
                if ( purchaseDateDeviceValue !== undefined &&
                      purchaseDateDeviceValue.isAfter( purchaseDateWarrantyValue ) ) {
                    nfFields.request( 'add:error', purchaseDateDevice.get('id'),
                                      'purchase-device-future',
                                      'Das Kaufdatum des Gerätes darf nicht größer sein als das Kaufdatum des Schutzbriefes.' );
                } else {
                    nfFields.request( 'remove:error', purchaseDateDevice.get('id'), 'purchase-device-future' );
                }

                // damageDate is before purchaseDateWarrantyValue
                if ( damageDateValue !== undefined && damageDateValue.isBefore( purchaseDateWarrantyValue ) ) {
                    nfFields.request( 'add:error',
                                        damageDate.get('id'),
                                        'damage-data-before-warranty',
                                        'Der Schadentag liegt außerhalb der Vertragslaufzeit.' );
                } else {
                    nfFields.request( 'remove:error', damageDate.get('id'), 'damage-data-before-warranty' );
                }

                // damageDate is after contractTermEndDate
                if ( damageDateValue !== undefined && damageDateValue.isAfter( contractTermEndDate ) ) {
                    nfFields.request( 'add:error', damageDate.get('id'), 'damage-date-after-expired', 'Der Schadentag liegt außerhalb der Vertragslaufzeit.' );
                } else {
                    nfFields.request( 'remove:error', damageDate.get('id'), 'damage-date-after-expired' );
                }
            }

            // check if gravis aktion
            if ( this.fieldModels[ 'schutzbrief_kaufdatum' ] !== "" ) {
                var purchaseDateWarrantyValue = moment(this.fieldModels[ 'schutzbrief_kaufdatum' ].get('value'), this.fieldModels[ 'schutzbrief_kaufdatum' ].get( 'date_format' ));

                if ( purchaseDateWarrantyValue.isAfter("2017-07-19") && purchaseDateWarrantyValue.isBefore("2017-09-04") ) {
                    this.fieldModels[ 'verkaufsaktion' ].set('value', 1);
                } else if ( purchaseDateWarrantyValue.isAfter("2018-01-01") && ['132794', '132795'].indexOf(this.fieldModels[ 'schutzbrief_artikelnr' ].get('value') > -1 ) ) {
                    this.fieldModels[ 'verkaufsaktion' ].set('value', 1);
                } else if (purchaseDateWarrantyValue.isAfter("2018-02-01") && ['132577', '131312', '131313', '131314', '131315'].indexOf(this.fieldModels['schutzbrief_artikelnr'].get('value')> -1 ) ) {
                    this.fieldModels[ 'verkaufsaktion' ].set('value', 1);
                } else if (purchaseDateWarrantyValue.isAfter("2018-11-06") && purchaseDateWarrantyValue.isBefore("2018-11-10") && ["130862", "130868"].indexOf(this.fieldModels["schutzbrief_artikelnr"].get("value")) > -1 ) {
                    this.fieldModels["verkaufsaktion"].set("value", 1);
                } else {
                    this.fieldModels["verkaufsaktion"].set("value", 0);
                }

                // change product codes
                if (purchaseDateWarrantyValue.isAfter("2022-03-21") && ['137428', '137429'].indexOf(this.fieldModels['schutzbrief_artikelnr'].get('value')) > -1 ) {

                    var productCode = this.fieldModels["produktcode"];

                    if ( purchaseDateWarrantyValue.isAfter("2022-05-15")) {
                        switch(this.fieldModels['schutzbrief_artikelnr'].get('value')) {
                          case '137428':
                            jQuery( '#nf-field-' + productCode.attributes.id ).val('GRVS005HCiX03').trigger('change');
                            break;
                          case '137429':
                            jQuery( '#nf-field-' + productCode.attributes.id ).val('GRVS005HCiM03').trigger('change');
                            break;
                          default:
                            break;
                        }
                    } else {
                        switch(this.fieldModels['schutzbrief_artikelnr'].get('value')) {
                          case '137428':
                            jQuery( '#nf-field-' + productCode.attributes.id ).val('GRVS004HCiX03').trigger('change');
                            break;
                          case '137429':
                            jQuery( '#nf-field-' + productCode.attributes.id ).val('GRVS004HCiM03').trigger('change');
                            break;
                          default:
                            break;
                        }
                    }
                }
            }

        },
        purchasePriceChange: function( calcModel ) {

            if (  calcModel.get( 'name' ) == 'selbstbehalt' && calcModel.get('value') > 0) {

                var selbstbehalt_nutzen = this.fieldModels[ 'selbstbehalt_nutzen' ],
                    selbstbehalt = this.fieldModels[ 'selbstbehalt' ];

                if ( selbstbehalt_nutzen.get( 'value' ) == 1 ) {
                    selbstbehalt.set( 'value', parseFloat(calcModel.get( 'value' )).toFixed( 2 ) );
                }
            }

            if ( calcModel.get( 'name' ) == 'handlingsfee_brutto' && calcModel.get( 'value' ) > 0 ) {

                var handlingsfee_brutto = this.fieldModels['handlingsfee_brutto'];
                handlingsfee_brutto.set( 'value', parseFloat(calcModel.get( 'value' )).toFixed( 2 ) );
            }
        },
        hiddenChange: function( model ) {

            if ( model.get('fides_field_key') === 'mandant_text' ) {
                // replace desc-text in datenschutzerklaerung
                var privacy_field = this.fieldModels[ 'datenschutzerklaerung' ];
                if ( privacy_field !== undefined ) {
                    var changed = privacy_field.changedAttributes();

                    if ( privacy_field.get('desc_text_original') === undefined ) {
                        privacy_field.set('desc_text_original', privacy_field.get('desc_text'));
                    }
                    desc = privacy_field.get('desc_text_original').replace('{mandant:text}', model.get('value')),

                    privacy_field.set('desc_text', desc);
                    privacy_field.trigger('reRender');
                }
            }


        },
        onSubmitResponse: function(  response, textStatus, jqXHR, form_id ) {
            // if ( 'error' === textStatus ) return;

            $('.nf-response-msg').show();
        }

    });
    new formController();

});
